"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRippleEffect = void 0;
var react_1 = require("react");
var useRippleEffect = function () {
    (0, react_1.useEffect)(function () {
        var handleClick = function (event) {
            var target = event.target;
            var rippleParent = target.closest('.ripple-effect');
            if (!rippleParent)
                return; // Only handle if element has .ripple-effect class
            var diameter = Math.max(rippleParent.clientWidth, rippleParent.clientHeight);
            var radius = diameter / 2;
            var ripple = document.createElement('span');
            ripple.className = 'ripple';
            ripple.style.width = ripple.style.height = "".concat(diameter, "px");
            ripple.style.left = "".concat(event.clientX - (rippleParent.getBoundingClientRect().left + radius), "px");
            ripple.style.top = "".concat(event.clientY - (rippleParent.getBoundingClientRect().top + radius), "px");
            // Remove any existing ripple effect
            var existing = rippleParent.querySelector('.ripple');
            if (existing)
                existing.remove();
            rippleParent.appendChild(ripple);
        };
        // Attach event listener to the document
        document.addEventListener('click', handleClick);
        // Cleanup on unmount
        return function () {
            document.removeEventListener('click', handleClick);
        };
    }, []);
};
exports.useRippleEffect = useRippleEffect;
